module.exports = __webpack_public_path__ + "45455fe5726425b48d0bd1d1d05dd3d1.svg";